const resources = {
    usName: 'United States',
    caName: 'Canada',
    firstName: 'First Name',
    lastName: 'Last Name',
    address2Label: 'Door buzzer, building code, Apt#...etc',
    add: 'Add',
    country: 'Country',
    streetAddress: 'Street Address',
    address: 'Address',
    address2: 'Address Line 2',
    startTyping: 'Start typing your address',
    city: 'City',
    phone: 'Phone',
    phoneNumber: 'Phone Number',
    postalCode: 'Postal Code',
    zipPostalCode: 'ZIP/Postal Code',
    emailAddress: 'Email Address',
    enterZipCodeText: 'Enter ZIP/Postal Code to see City and State/Region.',
    region: 'Region',
    stateRegion: 'State/Region',
    province: 'Province',
    emailRequiredText: 'Your email address is required for shipping notifications and order tracking.',
    optional: '(Optional)',
    phoneContext: '(for delivery questions)',
    keepTyping: 'Keep typing, include apt number, suite, building'
};

export default function getResource(label) {
    return resources[label];
}
